import React, { useCallback } from 'react';
import * as Styled from './VHProfileInfo.styled';
import IconLabelButton from '../IconLabelButton/IconLabelButton';
import VHProfileImage from '../../atoms/VHProfileImage/VHProfileImage';
import { useDispatch, useSelector } from 'react-redux';
import { virtualHumanDataSelector } from '../../../slices/VirtualHumanSlice';
import { setMoreInfoVisible } from '../../../slices/vh-player/VHPlayerSlice';
import { useTranslation } from 'react-i18next';

const VHProfileInfo = (props) => {
  const vh = useSelector(virtualHumanDataSelector);

  const dispatch = useDispatch();
  const handleMoreInfoClick = useCallback(() => {
    dispatch(setMoreInfoVisible(true));
  }, [dispatch]);

  const { t } = useTranslation();

  return (
    <Styled.ProfileInfoGrid>
      <Styled.ProfileImageArea>
        <VHProfileImage src={vh?.ThumbnailURL} />
      </Styled.ProfileImageArea>
      <Styled.ProfileName>
        <Styled.ProfileNameText>{vh?.Title}</Styled.ProfileNameText>
        <IconLabelButton
          size={0}
          onClick={handleMoreInfoClick}
          aria-label={t('moreInfo')}
        >
          {t('moreInfo')}
        </IconLabelButton>
      </Styled.ProfileName>
    </Styled.ProfileInfoGrid>
  );
};

export default VHProfileInfo;
